// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__--mL2","qualcommimg":"SponsorsSection_qualcommimg__YcQHm"};